export default __webpack_public_path__ + "7d2d301c1fa57a32e2b086393189d109.png";